
import Vue, { PropType } from 'vue';
import ResultAnswer from '@/side-bar/tabs/Polls/ResultAnswer.vue';

export default Vue.extend({
    components: {
        ResultAnswer
    },

    props: {
        question: {
            type: String,
            required: true,
        },
        results: {
            type: Array,
            default: () => ([])
        },
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        }
    }
});
